module.exports = __webpack_public_path__ + "static/img/logo3.558f874f.svg";